import { createFileRoute } from '@tanstack/react-router';

import { creditNoteListSearch, loadCreditNoteMessages, loadCreditNoteListScreen } from '@/modules/credit-note/route';
import { lazyScreen } from '@/shared/screen';

// Mesmo caminho do legado (`/ccb/operacoes`): o menu passa a apontar para cá pelo manifesto (U15).
export const Route = createFileRoute('/_app/ccb/operacoes/')({
  validateSearch: creditNoteListSearch,
  loader: () => loadCreditNoteMessages(),
  component: lazyScreen(loadCreditNoteListScreen, 'CreditNoteListScreen'),
});
